export default {
  props: {
    renderFormat: {
      type: Function,
      default: () => { }
    },
    row: {
      type: Object,
      default: () => { }
    },
    valueKey: {
      type: String,
      default: ''
    }
  },
  render(h) {
    return this.renderFormat(h, this.row, this.row[this.valueKey])
  }
}
